export default __webpack_public_path__ + "static/media/Dosis-Medium.50346366.ttf";